import React, { useState, useEffect } from "react";


import axios from "axios";
import "./App.css";

function UseCaseInput({ useCase, setUseCase }) {
  return (
    <input
      type="text"
      className="form-control"
      value={useCase}
      onChange={(e) => setUseCase(e.target.value)}
      placeholder="Enter your use case"
    />
  );
}

function InstructionSection({ show }) {
  if (!show) return null;

  return (
    <div className="instruction-section mt-4 mb-5">
      <h2>How it works</h2>
      <ol>
        <li>
          Select a demo type (Acronym Generation or Website Generation) from the dropdown.
        </li>
        <li> Enter some input (a title, or a website use case), then click "Start" to generate an initial acronym or a website layout.
        </li>
        <li>
          Click "Get Feedback" to receive suggestions for improvements. You can <b>edit the feedback</b> if you want.
        </li>

        <li>
          Click "Regenerate using feedback" to apply the feedback and see the updated acronym or website layout.
        </li>

        <span className="bullet">&#x1F4A1;</span> Repeat steps 3-5 to continue refining the output. If you don't want to get involved, just keep doing the "Get Feedback" and "Regenerate using feedback" steps and let the model self-refine!

      </ol>
    </div>
  );
}


function DemoSelection({ selectedDemo, setSelectedDemo }) {
  return (
    <select
      className="custom-select"
      value={selectedDemo}
      onChange={(e) => {
        setSelectedDemo(e.target.value);
      }}
    >
      <option value="acronym-generation">Acronym Generation</option>
      <option value="website-generation">Website Generation</option>
    </select>
  );
}

function GenerateWebsiteButton({ onClick }) {
  return (
    <button className="btn btn-outline-secondary" onClick={onClick}>
      Start
    </button>
  );
}

function WebsiteContainer({ htmlCode, iteration, isAcronym }) {
  const containerClass = `website-container border border-secondary p-2 mb-4 ${isAcronym ? 'acronym' : ''}`;
  const containerHeight = isAcronym ? '50' : '500';

  return (
    <div className="iteration-container">
      <div className="iteration-number badge badge-secondary">{iteration}</div>
      <div className={containerClass}>
        <iframe
          title={`iteration-${iteration}`}
          srcDoc={htmlCode}
          width="100%"
          height={containerHeight}
          frameBorder="0"
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  );
}


// function FeedbackList({ feedback }) {
//   const splitSentences = (text) => {
//     return text
//       .split(/\n+/)
//       .filter((sentence) => sentence.trim().length > 0);
//   };
//   // return (
//   //   <ul className="list-group">
//   //     {splitSentences(feedback).map((sentence, index) => (
//   //       <li key={index} className="list-group-item feedback-text">
//   //         {sentence.trim()}
//   //       </li>
//   //     ))}
//   //   </ul>
//   // );
//   return (<ul className="list-group">
//     <li className="list-group-item feedback-text">
//     {feedback}
//     </li>
//   </ul>);
// }

function FeedbackList({ feedback, feedbackLines, handleFeedbackChange }) {
  const feedbackLinesUpdated = feedbackLines < 10 ? 10 : feedbackLines;
  return (
    <div className="feedback-container">
      <textarea
        className="form-control feedback-textarea"
        value={feedback}
        onChange={handleFeedbackChange}
        rows={feedbackLinesUpdated}
      />
      <i className="fas fa-pencil-alt feedback-edit-icon" />
    </div>
  );
}




function GetFeedbackButton({ onClick }) {
  return (
    <button className="btn btn-primary mb-3" onClick={onClick}>
      Get Feedback
    </button>
  );
}

function RegenerateUsingFeedbackButton({ onClick }) {
  return (
    <button className="btn btn-warning mb-3 mt-3" onClick={onClick}>
      Regenerate using feedback
    </button>
  );
}

function LoadingOverlay() {
  return (
    <div className="spinner-overlay">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}


function App() {
  const [useCase, setUseCase] = useState("Enter something here");
  const [htmlCode, setHtmlCode] = useState("");
  const [previousHtml, setPreviousHtml] = useState([]);
  const [feedback, setFeedback] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [iterationCount, setIterationCount] = useState(0);
  const [selectedDemo, setSelectedDemo] = useState("acronym-generation");
  const [showInstructions, setShowInstructions] = useState(false);
  const [feedbackLines, setFeedbackLines] = useState(1);
  const resetPageState = () => {
    if (selectedDemo === "acronym-generation") {
      setUseCase("Cool Title for Which You Need an Acronym");
    } else if (selectedDemo === "website-generation") {
      setUseCase("Minimal website on cute kittens");
    }
    setHtmlCode("");
    setPreviousHtml([]);
    setFeedback("");
    setIterationCount(0);
  };
  useEffect(() => {
    resetPageState();
  }, [selectedDemo]);

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };
  const calculateFeedbackLines = (text) => {
    const lines = text.split(/(?<!\w\.\w.)(?<![A-Z][a-z]\.)(?<=\.|\?)\s/)
      .filter((line) => line.trim().length > 0);
    setFeedbackLines(lines.length);
  };

  useEffect(() => {
    calculateFeedbackLines(feedback);
  }, [feedback]);



  const resetPageStateWithoutUseCase = () => {
    setHtmlCode("");
    setPreviousHtml([]);
    setFeedback("");
    setIterationCount(0);
  };

  useEffect(() => {
    resetPageStateWithoutUseCase();
  }, [useCase]);


  useEffect(() => {
    if (selectedDemo === "acronym-generation") {
      setUseCase("Cool Title for Which You Need an Acronym");
    } else if (selectedDemo === "website-generation") {
      setUseCase("Minimal website on cute kittens");
    }
  }, [selectedDemo]);

  
  const fetchHtmlCode = async () => {
    try {
      setIsLoading(true);
      const apiEndpoint = selectedDemo === "website-generation"
        ? "/api/get-html"
        : "/api/generate-initial-acronym";
      const response = await axios.post(apiEndpoint, { useCase });
      setHtmlCode(response.data.html || response.data.acronym);
      setIterationCount(0); // Reset the iteration count

    } catch (error) {
      console.error("Error fetching HTML code:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const getFeedback = async () => {
    try {
      setIsLoading(true);
      const apiEndpoint = selectedDemo === "website-generation"
        ? "/api/get-feedback"
        : "/api/get-acronym-feedback";
      const requestData = selectedDemo === "website-generation"
        ? { htmlCode: htmlCode }
        : { useCase, acronym: htmlCode };

      const response = await axios.post(apiEndpoint, requestData);
      setFeedback(response.data.feedback);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    } finally {
      setIsLoading(false);
    }
  };




  const regenerateUsingFeedback = async () => {
    try {
      setIsLoading(true);
      const apiEndpoint = selectedDemo === "website-generation"
        ? "/api/regenerate-using-feedback"
        : "/api/refine-acronym";
      const requestData = selectedDemo === "website-generation" ? { htmlCode, feedback } : { title: useCase, acronym: htmlCode, feedback };
      const response = await axios.post(apiEndpoint, requestData);


      // Save the feedback and the HTML code for the current iteration before updating the state
      const currentIterationData = { html: htmlCode, feedback };

      setPreviousHtml((prevState) => [currentIterationData, ...prevState]);

      setHtmlCode(response.data.updatedHtml);

      setFeedback("");

    } catch (error) {
      console.error("Error regenerating website using feedback:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const resetPage = () => {
    window.location.reload();
  };


  return (
    <div className="App container">
      <button
        className="btn btn-danger reset-button"
        onClick={resetPage}
      >

        RESET
      </button>

      <h1 className="my-4">Self-Refine Demo</h1>
      <h3 className="mb-3">Research Demo</h3>

      <button
        className="btn btn-info mb-3"
        onClick={() => setShowInstructions(!showInstructions)}
      >
        {showInstructions ? "Hide Instructions" : "Show Instructions"}
      </button>
      <InstructionSection show={showInstructions} />



      <div className="input-group mb-3">
        <div className="input-group mb-3">
          <div className="demo-selection-container">
            <DemoSelection selectedDemo={selectedDemo} setSelectedDemo={setSelectedDemo} />
          </div>

        </div>

      </div>
      {/* Use Case Input and Generate Website Button */}
      <div className="input-group mb-3">
        <UseCaseInput useCase={useCase} setUseCase={setUseCase} />
        <div className="input-group-append">
          <GenerateWebsiteButton onClick={fetchHtmlCode} />
        </div>
      </div>

      <div className="website-wrapper">
        {/* Display previous iterations */}
        {previousHtml.slice().reverse().map((entry, index) => (
          <div key={index}>
            <WebsiteContainer
              htmlCode={entry.html}
              iteration={previousHtml.length - index}
              isAcronym={selectedDemo === 'acronym-generation'}

            />

            {/* Display feedback if available */}
            {entry.feedback && (
              <div className="feedback-container mb-4">
                <div className="arrow-box">↓</div>
                <FeedbackList feedback={entry.feedback} setFeedback={setFeedback} feedbackLines={feedbackLines} handleFeedbackChange={handleFeedbackChange} />
              </div>
            )}
          </div>
        ))}


        {/* Display current iteration */}
        <WebsiteContainer
          htmlCode={htmlCode}
          iteration={previousHtml.length + 1}
          isAcronym={selectedDemo === 'acronym-generation'}

        />

        {/* Get Feedback Button */}
        <GetFeedbackButton onClick={getFeedback} />

        {/* Display feedback and Regenerate Using Feedback Button */}
        {feedback && (
          <div>
            <FeedbackList feedback={feedback} setFeedback={setFeedback} feedbackLines={feedbackLines} handleFeedbackChange={handleFeedbackChange} />
            <RegenerateUsingFeedbackButton onClick={regenerateUsingFeedback} />
          </div>
        )}
      </div>

      {/* Display loading overlay */}
      {isLoading && <LoadingOverlay />}
    </div>
  );

}

export default App;
